import { render, staticRenderFns } from "./Sector.vue?vue&type=template&id=02c08b74&scoped=true"
import script from "./Sector.vue?vue&type=script&lang=js"
export * from "./Sector.vue?vue&type=script&lang=js"
import style0 from "./Sector.vue?vue&type=style&index=0&id=02c08b74&prod&lang=css"
import style1 from "./Sector.vue?vue&type=style&index=1&id=02c08b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c08b74",
  null
  
)

export default component.exports